import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Checkbox, Input } from "@unified-checkout/design-system";

import {
  useCheckoutCustomizationStore
} from "@app/dashboard/store/checkout-customization";
import {
  PAYMENT_CONFIRMATION_MSG_MAX_CHARS,
  PAYMENT_CONFIRMATION_MSG_MIN_CHARS
} from "../../../../utils";
import { Title } from "../../../../components/Title";
import styles from "./payment-confirmation.module.scss";


export const PaymentConfirmation = () => {
  const { t } = useTranslation();

  const {
    isFetched,
    isDataReset,
    customizationData,
    setCustomizationData
  } = useCheckoutCustomizationStore();

  const { post_payment } = customizationData;
  const { useCustomMessage, message } = post_payment;

  const [inputValue, setInputValue] = useState(t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.paymentConfirmation.defaultConfirmationMsg'));
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const storedErrMsg = useRef<string>();

  const invalidLength =
    inputValue.length > PAYMENT_CONFIRMATION_MSG_MAX_CHARS ||
    inputValue.length < PAYMENT_CONFIRMATION_MSG_MIN_CHARS;

  useEffect(() => {
    setErrMsg(invalidLength ? t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.paymentConfirmation.errors.enterValidMsg') : "");

    setCustomizationData(prevData => ({
      ...prevData,
      post_payment: {
        ...prevData.post_payment,
        message: inputValue
      }
    }));

  }, [inputValue]);

  useEffect(() => {
    if (isInputVisible) {
      const storedMsg = storedErrMsg.current || '';
      setErrMsg(storedMsg);
    } else {
      storedErrMsg.current = errMsg;
      setErrMsg('');
    }
  }, [isInputVisible]);

  useEffect(() => {
    if (isFetched) {
      setInputValue(message || t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.paymentConfirmation.defaultConfirmationMsg'));
      setIsInputVisible(!!useCustomMessage);
    }
  }, [isFetched, isDataReset]);

  const handleCheckboxClick = (checked: boolean) => {
    setIsInputVisible(checked);

    setCustomizationData(prevData => ({
      ...prevData,
      post_payment: {
        ...prevData.post_payment,
        useCustomMessage: checked
      }
    }));
  };

  const handleMsgChange = (e: any) => {
    const value = e.target.value;
    setInputValue(value);
  };

  return (
    <div className={styles["payment-confirmation"]}>
      <Title
        label={t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.paymentConfirmation.label')}
      />
      <Checkbox
        id="payment-confirmation-msg-chb"
        hintText={t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.paymentConfirmation.createCustomMessage')}
        onClickHandler={handleCheckboxClick}
        selected={isInputVisible}
      />

      {
        isInputVisible &&
        <>
          <Input
            name="payment-confirmation-msg-input"
            placeholder={t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.paymentConfirmation.placeholders.message')}
            value={inputValue}
            onChange={handleMsgChange}
            status={invalidLength ? "error" : "default"}
          />

          <div
            className={styles["payment-confirmation__chars-count"]}
            data-confirmation-msg-invalid-length={invalidLength}
          >
            {`
        ${inputValue.length}/${PAYMENT_CONFIRMATION_MSG_MAX_CHARS} 
        ${t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.paymentConfirmation.character')}
        `}
          </div>

          {
            errMsg &&
            <div className={styles["payment-confirmation__err-msg"]}>
              {errMsg}
            </div>
          }
        </>
      }


    </div>
  )
}
